import React from 'react';
import moment from 'moment';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { Modal, Fade, Backdrop, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import FilterForm from './FilterForm';
import { getProposalsByPage } from '../../../store/actions/ProposalsAction';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 'fit-content',
    borderRadius: 4,
    padding: 0,
    margin: 0,
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
  },
  infoWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    width: 'fit-content',
  },
  closeContainer: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  close: {
    margin: '24px 24px 0 0',
  },
});

const ProposalFilter = ({ handleClickFilter, getProposalsByPage, setSearchValues, uid, showLoading, hideLoading }) => {
  const classes = useStyles();

  const handleSubmit = async (values) => {

    const params = {
      ...values,
      uid: uid,
      page: 1,
      limit: 9,
    };
    
    const objectArray = Object.entries(values);

    let valuesArray = [];
    objectArray.forEach(([key, value]) =>
      key === 'createdAt' && value
        ? valuesArray.push(moment(value).utc().format('DD/MM/YY'))
        : valuesArray.push(value)
    );

    const searchValues = valuesArray.filter((item) => item);

    /* if (values.createdAt) {
      values['createdAt'] = moment(values.createdAt).unix();
    } */

    console.log('params', params)
    console.log('searchValues', searchValues)
    console.log('createdAt', values.createdAt)

    showLoading();
    await getProposalsByPage(params)
      .then((res) => {
        setSearchValues(searchValues);
        hideLoading();
        handleClickFilter();
      })
      .catch((error) => {
        console.log(error);
        hideLoading();
      });
  };

  const handleCleanFilter = async () => {
    showLoading()
    const params = {
      uid: uid,
      page: 1,
      limit: 9,
    };

    setSearchValues([]);
    await getProposalsByPage(params)
      .then((res) => {
        hideLoading();
        handleClickFilter();
      })
      .catch((error) => {
        console.log(error);
        hideLoading();
      });

  }

  const formValues = {
    createdAt: null,
    status: '',
  };

  return (
    <div>

        <Formik
          initialValues={formValues}
          //validationSchema={validationAdminArticleFilter}
          onSubmit={handleSubmit}
          render={(props) => (
            <FilterForm
              {...props}
              handleCleanFilter={handleCleanFilter}
            />
          )}
        />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getProposalsByPage: params => dispatch(getProposalsByPage(params)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
})

export default connect(null, mapDispatchToProps)(ProposalFilter);
